import React, { useState } from "react";
import classes from "./ReviewsMobile.module.css";
import { Container, Row, Col } from "react-bootstrap";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { InputWithSearchIcon } from "../../../stories/InputWithSearchIcon/InputWithSearchIcon";
import {
  coachDemoImg,
  bookingIconGray,
  HomeIconGray,
  messageIconGray,
  NotificationIconGray,
  ProfileIconGray,
  ReviewsWithHeartIcon,
  search_svg,
} from "../../../constant/imagePath";
import { ReviewModal } from "../../../components/Modals/CoachFlow/Reviews/ReviewModal";

import FilterModal from "../../../components/Modals/CoachFlow/Reviews/FilterModal/FilterModal";
import { ReviewBox } from "../../../stories/ReviewBox/ReviewBox";
import Ratings from "react-star-ratings";
import { useHistory, useLocation } from "react-router";
import MobileBottomTab from "../../../stories/MobileBottomTab/MobileBottomTab";
import moment from "moment";
import { ReactSVG } from "react-svg";

function NoResults() {
  return (
    <div className={classes.noResults}>
      <div>
        <ReactSVG src={search_svg} />
        <h2
          style={{
            ...Fonts.h3,
            fontSize: "24px",
            lineHeight: "32px",
            color: Colors.neutralShadesOfNero,
          }}
        >
          No results
        </h2>
        <p
          style={{
            ...Fonts.p1,
            fontSize: "14px",
            color: Colors.neutralShadesOfDimGray,
          }}
        >
          It seems we can’t find any results based on your search.
        </p>
      </div>
    </div>
  );
}
function NoReviewsYet() {
  return (
    <div className={classes.noReviewsYet}>
      <div>
        <ReactSVG src={ReviewsWithHeartIcon} />
        <h2
          style={{
            ...Fonts.h3,
            fontSize: "24px",
            lineHeight: "32px",
            color: Colors.neutralShadesOfNero,
          }}
        >
          You have no reviews yet
        </h2>
        <p
          style={{
            ...Fonts.p1,
            fontSize: "14px",
            color: Colors.neutralShadesOfDimGray,
          }}
        >
          As soon as the student decides to leave you a review, it will appear
          here.{" "}
        </p>
      </div>
    </div>
  );
}

const ReviewsMobile = () => {
  const history = useHistory();
  const [menuItem, setMenuItem] = useState("reviews");
  const [isOpen, setIsOpen] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  const staticData = [
    {
      user: {
        photo: coachDemoImg,
        displayName: "Michael Baumgardner",
      },
      // Review Details
      text: "This is my first review",
      createdAt: moment("Feb 10,2022").format("MMM DD,YYYY"),
      rating: 4,
      tags: ["Friendly", "Focused"],
      type: "view-lesson",
    },
    {
      user: {
        photo: coachDemoImg,
        displayName: "Michael Baumgardner",
      },
      // Review Details
      text: "John has a knack. He can teach through his writings. He inspires confidence in his students, and by reading. Watch the Ball, you'll be inspired too.",
      createdAt: moment("June 12,2022").format("MMM DD,YYYY"),
      rating: 5,
      tags: ["Friendly", "Focused"],
      type: "view-lesson",
    },
    {
      user: {
        photo: coachDemoImg,
        displayName: "Michael Baumgardner",
      },
      // Review Details
      text: "John has a knack. He can teach through his writings. He inspires confidence in his students, and by reading. Watch the Ball, you'll be inspired too.",
      createdAt: moment("June 15,2022").format("MMM DD,YYYY"),
      rating: 3,
      tags: ["Friendly", "Focused"],
      type: "view-lesson",
    },
    {
      user: {
        photo: coachDemoImg,
        displayName: "Michael Baumgardner",
      },
      // Review Details
      text: "John has a knack. He can teach through his writings. He inspires confidence in his students, and by reading. Watch the Ball, you'll be inspired too.",
      createdAt: moment("March 10,2022").format("MMM DD,YYYY"),
      rating: 2,
      tags: ["Friendly", "Focused"],
      type: "view-lesson",
    },
    {
      user: {
        photo: coachDemoImg,
        displayName: "Michael Baumgardner",
      },
      // Review Details
      text: "John has a knack. He can teach through his writings. He inspires confidence in his students, and by reading. Watch the Ball, you'll be inspired too.",
      createdAt: moment("May 6,2022").format("MMM DD,YYYY"),
      rating: 1,
      tags: ["Friendly", "Focused"],
      type: "view-lesson",
    },
    {
      user: {
        photo: coachDemoImg,
        displayName: "Michael Baumgardner",
      },
      // Review Details
      text: "John has a knack. He can teach through his writings. He inspires confidence in his students, and by reading. Watch the Ball, you'll be inspired too.",
      createdAt: moment("Jul 10,2022").format("MMM DD,YYYY"),
      rating: 5,
      tags: ["Friendly", "Focused"],
      type: "view-lesson",
    },
  ];
  const [search, setSearch] = useState("");
  const [reviewdata, setReviewdata] = useState(staticData);
  const profileReview = {
    data: {
      studentsSayings: [
        "Friendly to kids",
        "Competitive",
        "Discipline",
        "Caring",
      ],
    },
    review: {
      totalRating: 12,
      rating: 3,
      reviewsTypes: [
        {
          title: "Accuracy",
          progress: "60%",
          rating: "4.0",
        },
        {
          title: "Location",
          progress: "100%",
          rating: "5.0",
        },
        {
          title: "Value",
          progress: "40%",
          rating: "3.0",
        },
        {
          title: "Communication",
          progress: "100%",
          rating: "5.0",
        },
      ],
    },
  };
  return (
    <div className={[classes.ReviewScreen].join(" ")}>
      <Container fluid className={[classes.container].join(" ")}>
        <Row className={["g-0", classes.row, classes.pb32].join(" ")}>
          <Col sm={12} className={[classes.mb24].join(" ")}>
            <div
              className={[
                classes.dflex,
                classes.contentbetween,
                classes.itemcenter,
                classes.mb16,
              ].join(" ")}
            >
              <h2
                style={{
                  ...Fonts.h2,
                  color: Colors.neutralShadesOfNero,
                  fontSize: "26px",
                  lineHeight: "32px",
                }}
              >
                Reviews
              </h2>
              <div className={[classes.itemcenter, classes.dflex].join(" ")}>
                <Ratings
                  numberOfStars={1}
                  starRatedColor={Colors.mainShadeOfRed}
                  starEmptyColor={Colors.neutralShadesOfGainsboro}
                  rating={profileReview?.review?.rating / 5}
                  starDimension={"24px"}
                  starSpacing={"4px"}
                />
                <h4
                  className={[classes.ml8].join(" ")}
                  style={{ ...Fonts.h4, color: Colors.neutralShadesOfNero }}
                >
                  {profileReview?.review?.rating.toFixed(1)}
                </h4>
              </div>
            </div>
            <InputWithSearchIcon
              state={search}
              setter={setSearch}
              placeholder="Search"
              isShowFilter={true}
              onFilter={() => setShowFilters(true)}
            />
          </Col>

          {search == "" &&
            reviewdata?.map((item, i) => {
              return (
                <Col
                  sm={12}
                  key={i}
                  className={[
                    classes.pb32,
                    classes.mb32,
                    classes.borderBottom,
                  ].join(" ")}
                >
                  <ReviewBox
                    reviewData={item}
                    onClick2={() => setIsOpen(true)}
                    onClick1={() => history.push('/chat')}
                  />
                </Col>
              );
            })}
          {search !== "" && <NoResults />}
          {reviewdata?.length == 0 && <NoReviewsYet />}
        </Row>

        {isOpen && (
          <ReviewModal
            show={isOpen}
            setShow={setIsOpen}
            profileReviewData={profileReview}
          />
        )}
        {showFilters && (
          <FilterModal
            setShow={setShowFilters}
            show={showFilters}
            data={reviewdata}
            setData={setReviewdata}
            staticData={staticData}
          />
        )}
      </Container>
      <div className={classes.BottomTab}>
        <MobileBottomTab state={menuItem}
        //  menus={demoData}
        />
      </div>
    </div>
  );
};
export default ReviewsMobile;
